export const CART_STORAGE_KEY = 'deeznuts_cart_v1';

/** Normalize parsed JSON into a valid cart array (client-only). */
export function normalizeCart(parsed) {
  if (!Array.isArray(parsed)) return [];
  return parsed.filter(
    (item) =>
      item &&
      typeof item.id === 'number' &&
      typeof item.quantity === 'number' &&
      item.quantity > 0 &&
      typeof item.price === 'number'
  );
}

export function loadCartFromStorage(storage = localStorage) {
  try {
    const raw = storage.getItem(CART_STORAGE_KEY);
    if (!raw) return [];
    return normalizeCart(JSON.parse(raw));
  } catch {
    return [];
  }
}

export function saveCartToStorage(cart, storage = localStorage) {
  try {
    storage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
  } catch {
    // Quota or private mode — ignore
  }
}
